module.exports = __webpack_public_path__ + "static/img/7b.a3aace5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7b.jpg
// module id = yiIY
// module chunks = 0